/**
 * SectionDivider.tsx — Separador centrado con etiqueta y contador
 *
 * UID-03b | Fase 3 | feat/step3-coteja
 * @date 2026-03-06
 */

import type { FC, CSSProperties } from 'react';
import { colors, typography } from '@/design-system/v2';

interface SectionDividerProps {
  label: string;
  count: number;
  color: string;
}

export const SectionDivider: FC<SectionDividerProps> = ({ label, count, color }) => {
  const wrapStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '20px 0 12px',
    fontFamily: typography.fontFamily.sans,
  };

  const lineStyle: CSSProperties = {
    flex: 1,
    height: '1px',
    background: colors.border.DEFAULT,
  };

  const labelStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.semibold,
    color,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  };

  const badgeStyle: CSSProperties = {
    fontFamily: typography.fontFamily.mono,
    fontSize: typography.fontSize['2xs'],
    padding: '1px 6px',
    borderRadius: '9999px',
    background: `${color}22`,
    color,
  };

  return (
    <div style={wrapStyle}>
      <div style={lineStyle} />
      <div style={labelStyle}>
        {label}
        <span style={badgeStyle}>{count}</span>
      </div>
      <div style={lineStyle} />
    </div>
  );
};
